<template>
    <header class="header" :class="{ 'header-open': showHeader }">
        <img src="@/assets/images/index/header-logo-active.png" alt="" v-show="showHeader" @click="gotoNavIndex">
        <img src="@/assets/images/index/header-logo.png" alt="" v-show="!showHeader" @click="gotoNavIndex">
        <!-- 导航栏 -->
        <ul>
            <li class="nav" v-for="(item, index) in menuList" :key="index" @mousemove="show(item)"
                @mouseleave="hide(item)">
                <nav @click="gotoNav(item.path, index)" :class="{ 'active': activeIndex == index && showHeader }">{{
                    item.name }}
                </nav>
                <div class="nav-bottom" :class="{ 'nav-bottoms': activeIndex == index, 'nav-bottom-top': !showHeader }">
                </div>
                <!-- 解决方案 -->
                <div class="nav-content-one nav-content"
                    :class="{ 'nav-content-open': item.showChildrenOne, 'radius': showChildren }"
                    v-if="item.name == '解决方案' || item.name == '成功案例'">
                    <div class="nav-content-box" v-for="(items, indexs) in item.children" :key="indexs"
                        @click="gotoNav(items.path, index, items.data)" @mouseover="openChild(item.name, items)"
                        @mouseleave="showChildren = false">{{ items.name }}
                        <div class=" line"></div>
                    </div>
                    <div class="nav-content-children" :class="{ 'nav-content-children-open': showChildren }"
                        @click="gotoNavTwo" @mouseover="showChildren = true" @mouseleave="showChildren = false">
                        <img v-lazy="fanganone" alt="" v-if="navData.name == '冲压线第八代AI节能解决方案'">
                        <img v-lazy="anlione" alt="" v-if="navData.name == '国和机械智慧AI节能案例'">
                        <img v-lazy="anlitwo" alt="" v-if="navData.name == '百亚集团设备能耗数字看板案例'">
                        <img v-lazy="anlithree" alt="" v-if="navData.name == '日本某塑料再生工厂智慧能耗管理案例'">
                        <img v-lazy="anlifour" alt="" v-if="navData.name == '设备智慧节能系统成功案例'">
                        <div class="title">{{ navData.title }}</div>
                        <div class="content">{{ navData.content }}</div>
                        <div class="btn">了解详情 +</div>
                    </div>
                </div>
                <!-- 关于我们 -->
                <div class="nav-content-two nav-content"
                    :class="{ 'nav-content-open': item.showChildrenTwo, 'radius': showChildren, 'nav-content-index': item.name == '首页' }"
                    v-show="item.name == '关于我们' || item.name == '资讯动态' || item.name == '首页'">
                    <div class="nav-content-box" v-for="(items, indexs) in item.children" :key="indexs"
                        @mouseover="openChild(item.name)" @mouseleave="showChildren = false"
                        @click="gotoNav(items.path, index)">{{ items.name }}
                        <div class="line"></div>
                    </div>
                    <!-- <div class="nav-content-children" :class="{ 'nav-content-children-open': showChildren }"
                        @mouseover="showChildren = true" @mouseleave="showChildren = false"></div> -->
                </div>
                <!-- 产品中心 -->
                <div class="nav-content-three nav-content"
                    :class="{ 'nav-content-open': item.showChildrenThree, 'radius': showChildren }">
                    <div class="nav-content-box" v-for="(items, indexs) in item.children" :key="indexs"
                        @click="gotoNav(items.path, index)" @mouseover="openChild(item.name)"
                        @mouseleave="showChildren = false">{{ items.name }}
                        <img src="@/assets/images/index/lefticon.png" alt="">
                        <div class="line"></div>
                        <div v-for="(itemss, indexss) in items.children" :key="indexss">
                            <div class="title">设备数据湖<img src="@/assets/images/index/lefticon.png" alt=""></div>
                        </div>
                    </div>
                    <!-- <div class="nav-content-children" :class="{ 'nav-content-children-open': showChildren }"
                        @mouseover="showChildren = true" @mouseleave="showChildren = false"></div> -->
                </div>
            </li>
        </ul>
        <!-- 右侧 -->
        <div class="nav-right">
            <div style="position: absolute;right:17.5rem;" :style="{ color: showHeader ? 'black' : '#fff' }">CN</div>
            <img src="@/assets/images/index/header-search.png" alt="" v-show="!showHeader">
            <img src="@/assets/images/index/phone.png" alt="" v-show="!showHeader">
            <img src="@/assets/images/index/header-search-active.png" alt="" v-show="showHeader">
            <img src="@/assets/images/index/header-phone-active.png" alt="" v-show="showHeader">
            <!-- <img src="@/assets/images/index/phone.png" alt=""> -->
            <div :style="{ color: showHeader ? 'black' : '#fff' }">023-62757988</div>
        </div>
    </header>
</template>

<script setup>
import fanganone from '@/assets/images/header/fangan-one.png'
import anlione from '@/assets/images/header/nav-anli-one.png'
import anlitwo from '@/assets/images/header/nav-anli-two.png'
import anlithree from '@/assets/images/header/nav-anli-three.png'
import anlifour from '@/assets/images/header/nav-anli-four.png'
import { ref, onMounted, watch } from "vue";
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
const store = useStore()
watch(() => store.state.navIndex, (newValue,) => {
    activeIndex.value = newValue
})
onMounted(() => {
    console.log(112221, store.state)
    activeIndex.value = store.state.navIndex
    window.addEventListener('scroll', handleScroll) // 监听页面滚动
})
// 去往溢希恩真
const gotoNavIndex = () => {
    router.push({
        path: '/index'
    })
}
const showHeader = ref(false)
const handleScroll = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    if (scrollTop == 0) {
        showHeader.value = false
    } else {
        showHeader.value = true
    }
}
const router = useRouter()
// 方案内容
const navData = ref({})
// 展开导航栏
// 导航栏
const menuList = ref([
    {
        name: '首页',
        path: '/index',
        showChildren: false,
        children: [
            {
                name: '溢希恩真',
                path: '/'

            },
            {
                name: '大云端科技',
                path: 'https://www.indubd.com'

            },
        ]
    },
    {
        name: '产品中心', showChildren: false, children: [

            {
                name: '“工业AI节能”产品体系',
                path: '/product-center/industry-AI'
                //  children: [
                //     { name: '设备数据湖' }
                // ]
            },
            {
                name: '设备能耗数字看板',
                path: '/product-center/EEDK'
            },
            {
                name: '设备智慧节能系统',
                path: '/product-center/EIES'
            },
            {
                name: '  冲压线AI节能模型',
                path: '/product-center/PLES'
            },


        ]
    },
    {
        name: '解决方案',
        showChildren: false,
        children: [{
            name: '冲压线第八代AI节能解决方案',
            path: '/solution',
            data: '冲压',
            title: '冲压线第八代AI节能解决方案',
            content: '通过设备能耗数字看板、设备智慧节能系统和冲压线AI节能模型的协同作用，该方案能够从数据采集......'
        },
        ]
    },
    {
        name: '成功案例',
        showChildren: false,
        path: '/success-cases',
        children: [{
            name: '国和机械智慧AI节能案例',
            path: '/success-cases/detail',
            data: 'one',
            title: '国和机械智慧AI节能案例',
            content: '为了应对生产线节拍不一致的问题，国和机械对四台压机的冲压生产线进行了智能化升级。通过......'
        },

        {
            name: '日本某塑料再生工厂智慧能耗管理案例',
            path: '/success-cases/detail',
            data: 'two',
            title: '日本某塑料再生工厂智慧能耗管理案例',
            content: '通过设备能耗数字看板和智慧能源监控平台，该工厂成功建立了一套覆盖全面、功能强大的智慧能耗......'
        }, {
            name: '百亚集团设备能耗数字看板案例',
            path: '/success-cases/detail',
            data: 'three',
            title: '百亚集团设备能耗数字看板案例',
            content: '为破解能源管理难题，大云端科技为百亚集团打造了设备能耗数字看板。通过“硬件+软件”的深度结......'
        },
        {
            name: '设备智慧节能系统成功案例',
            path: '/success-cases/detail',
            data: 'four',
            title: '设备智慧节能系统成功案例集',
            content: '本案例集涵盖了国内多家知名企业的液压机、压铸机及全厂节能改造实践，包括成都高原汽车（吉利......'
        },

        ]
    },
    {
        name: '资讯动态 ', showChildren: false, path: '/consulting-news', children: [
            {
                name: '行业观察',
                path: '/consulting-news',

            },
            {
                name: '企业新闻',

            },
            {
                name: '行业动态',

            },
            {
                name: '视频推荐',

            }
        ]
    },
    {
        name: '关于我们', showChildren: false, children: [
            {
                name: '公司简介',
                path: '/my/company-profile'

            },
            {
                name: '顶尖团队',
                path: '/my/core-team'

            },
            {
                name: '核心优势',
                path: '/my/core-advantage'

            },
            {
                name: '发展历程',
                path: '/my/development-history'

            },
            {
                name: '资质荣誉',
                path: '/my/honor'

            },
            {
                name: '联系我们 ',
                path: '/my/contant-us'
            }
        ]
    },
])
// 激活索引
const activeIndex = ref(0)
// 激活索引
const showChildren = ref(false)
// 展开二级菜单
const show = (item) => {
    if (item.name == '解决方案' || item.name == '成功案例') {
        item.showChildrenOne = true
    }
    if (item.name == '资讯动态' || item.name == '关于我们' || item.name == '首页') {
        item.showChildrenTwo = true
    }
    if (item.name == '产品中心') {
        item.showChildrenThree = true
    }
    // if (item.name == '资讯动态' || item.name == '关于我们') {

    // }

}
// 关闭二级菜单
const hide = (item) => {
    item.showChildrenOne = false
    item.showChildrenTwo = false
    item.showChildrenThree = false
}
const openChild = (name, item) => {
    console.log(name)
    if (name == '解决方案' || name == '成功案例') {
        showChildren.value = true
        navData.value = item

    }
}
// 跳转去往其他页面
const gotoNav = (path, index, data) => {
    if (path) {
        if (path == 'https://www.indubd.com') {
            window.open(path)
            return
        }
        router.push({
            path: path,
            query: {
                'data': data
            }
        })
        activeIndex.value = index
        store.commit('setNavIndex', index)
    }

}
// 去往解决方案和成功案例
const gotoNavTwo = () => {
    if (navData.value.path) {
        router.push({
            path: navData.value.path,
            query: {
                'data': navData.value.data
            }
        })
    }
}
</script>

<style lang="less" scoped>
// @import '@/assets/styles/variables.less';

@keyframes navTo {
    from {
        width: 0%;
    }

    to {
        width: 100%;
    }

}

.header-open {
    background-color: #fff !important;
    box-shadow: 0 0 .375rem #ccc !important;
    color: #000 !important;
}

.header {
    cursor: pointer;
    z-index: 999;
    position: absolute;
    top: 0;
    position: sticky;
    left: 0;
    width: 100%;
    height: 5.25rem;
    background-color: transparent;
    padding-left: 3.75rem;
    padding-right: 3.75rem;
    display: flex;
    align-items: center;
    transition: all .5s;
    color: #fff;


    img {
        width: 9.8125rem;
        height: 3.4375rem;
        ;
    }

    ul {
        display: flex;
    }
}

.nav {
    height: 5.25rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    margin-left: 58px;
    font-size: 1.125rem;
    position: relative;
    box-sizing: border-box;



    &:hover {
        // color: @xtxColor;


        .nav-bottom {
            width: 100%;

        }
    }

    nav {
        width: 100%;
        height: 5.125rem;
        line-height: 5.125rem;

        &.active {
            color: @xtxColor;
        }
    }



    .nav-bottom {
        width: 0px;
        height: .125rem;
        background-color: @xtxColor;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        transition: all 0.5s;
    }

    .nav-bottom-top {
        background-color: #fff;
    }

    .nav-bottoms {
        width: 100%;
    }
}

.nav-content {
    &.nav-content-open {
        opacity: 1;
        visibility: visible;
        transform: none;
    }

    &.radius {
        border-radius: .1875rem 0 0 .1875rem;
    }

    position: absolute;
    top: 5.75rem;
    left: 0;

    // height: 26.5rem;
    opacity: 0;
    visibility: hidden;
    box-shadow: 0 0 5px #ccc;
    transform: translateY(-0.625rem);
    transition: all 0.2s;
    background: #fff;
    color: #000;
    border-radius: .1875rem;

    .nav-content-box {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
        font-size: 1.125rem;
        width: 100%;
        height: 4.875rem;
        text-align: left;
        line-height: 4.875rem;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-wrap: nowrap;
        // border-bottom: .125rem solid #ECEDEE;
        position: relative;

        .line {
            margin-top: -0.125rem;
            height: .0625rem;
            width: 100%;
            background: #ECEDEE;
        }

        &:hover {
            color: @xtxColor;
            background: #F2F4F6;
            border-radius: .1875rem;
        }
    }
}

.nav-content-one {
    width: 23.125rem;
    height: 26.5rem;

    .nav-content-children {
        &.nav-content-children-open {
            opacity: 1;
            transform: none;
        }

        padding-left: 3.125rem;
        padding-right: 3.125rem;
        padding-top: 1.875rem;
        width: 28.75rem;
        height: 26.5rem;
        background: #F2F4F6;
        position: absolute;
        top: 0;
        left: 23.125rem;
        opacity: 0;
        transition: all 0.2s;

        img {
            width: 22.5rem;
            height: 11.25rem;
        }

        .title {
            text-align: left;
            font-weight: bold;
            font-size: 1.125rem;
            color: #000000;
            margin-top: 1.375rem;
        }

        .content {
            font-size: 1rem;
            color: #666666;
            margin-top: 1.125rem;
            text-align: left;
        }

        .btn {
            margin-top: 1.875rem;
            font-size: 1rem;
            color: @xtxColor;
            text-align: left;
        }
    }
}

.nav-content-two {
    width: 9.625rem;
}

.nav-content-index {
    width: 11rem
}

.nav-content-three {
    width: 34rem;

    .nav-content-box {
        font-size: 1.125rem;
        height: 100%;
        font-size: 1rem;
    }

    img {
        width: .4375rem;
        height: .6875rem;
        margin-left: .5rem;
    }
}

.nav-right {
    position: absolute;
    right: 3.75rem;
    height: 5.25rem;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 1.25rem;
    width: 13.75rem;
    justify-content: space-between;

    div {
        transition: all 0.2s;

        &:hover {
            transform: scale(1.1);
        }
    }

    img {
        width: 1.5rem;
        height: 1.5rem;
        transition: all 0.2s;

        &:hover {
            transform: scale(1.2);
        }
    }
}
</style>